import React, {useEffect, useRef} from 'react';
import {Empty, Skeleton, Space, Typography} from 'antd';
import {ShoppingOutlined} from '@ant-design/icons';
import styled from 'styled-components';
import ENDPOINTS from '../../constants/endpoints';
import {BORDER_GRAY, WHITE} from '../../utils/colors';
import OrderCard from '../../components/shop/OrderCard';
import useDefaultRequest from '../../hooks/useDefaultRequest';

const SkeletonCard = styled.div`
    background: ${WHITE};
    border: 1px solid ${BORDER_GRAY};
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 16px;
    padding: 16px 20px;
`;

const Sentinel = styled.div`
    height: 1px;
`;

export default function ShopOrders() {
    const sentinelRef = useRef(null);

    const {data: orders = [], isLoading, response, nextPage} = useDefaultRequest({
        url: ENDPOINTS.ECOMMERCE_ORDER_LIST,
        params: {page_size: 10},
        hasPagination: true,
        dataDefault: [],
    });

    const hasMore = !!response?.data?.next;

    useEffect(() => {
        if (!sentinelRef.current) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && hasMore && !isLoading) nextPage();
            },
            {threshold: 0.1}
        );
        observer.observe(sentinelRef.current);
        return () => observer.disconnect();
    }, [hasMore, isLoading, nextPage]);

    if (!isLoading && orders.length === 0) {
        return (
            <Empty
                image={<ShoppingOutlined style={{fontSize: 56, color: '#ccc'}}/>}
                description="Você ainda não possui pedidos"
                style={{marginTop: 40}}
            />
        );
    }

    return (
        <>
            <Typography.Title level={4} style={{marginBottom: 20}}>Meus Pedidos</Typography.Title>

            {orders.map(order => (
                <OrderCard key={order.id} order={order}/>
            ))}

            {isLoading && (
                <Space direction="vertical" style={{width: '100%'}} size={0}>
                    {[1, 2].map(i => (
                        <SkeletonCard key={i}>
                            <Skeleton active paragraph={{rows: 3}} title={{width: 200}}/>
                        </SkeletonCard>
                    ))}
                </Space>
            )}

            <Sentinel ref={sentinelRef}/>
        </>
    );
}
